export default __webpack_public_path__ + "static/media/four.69d7f90c.jpg";